module.exports = __webpack_public_path__ + "img/sc_summary_Image.635c4d80.png";